import type { ConversationMessageEntity } from '../../types/conversation.types';

/**
 * Builds a whole message entity from the few fields a mock cares about, so the
 * public and admin mocks hand the UI exactly what the real API would - every
 * key present, nothing the renderer has to guess.
 */

/* Unique enough for a mock and never colliding with a real UUID's shape. */
const mockClientId = () =>
  `mock-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;

export type MockMessageFields = Partial<ConversationMessageEntity> &
  Pick<ConversationMessageEntity, 'id' | 'conversationId' | 'side'>;

export const mockMessage = (
  fields: MockMessageFields
): ConversationMessageEntity => ({
  sender: null,
  isAssistant: false,
  body: null,
  attachments: [],
  orderId: null,
  replyTo: null,
  clientMessageId: mockClientId(),
  systemEvent: null,
  systemMeta: null,
  mentionUserIds: [],
  seen: false,
  editedAt: null,
  deletedAt: null,
  createdAt: new Date().toISOString(),
  actionProposal: null,
  ticket: null,
  quickReplies: null,
  audience: 'everyone',
  ...fields,
});

/** How long ago, as an ISO date - for seeding a believable history. */
export const minutesAgo = (minutes: number) =>
  new Date(Date.now() - minutes * 60000).toISOString();
